import { productCarouselStyles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCarouselStyles.titleText = {
    variant: "h3",
    css: css`
        text-align: left;
        margin: 30px;
        text-transform: uppercase;
        color: ${getColor("primary")};
    `,
};
productCarouselStyles.prevArrowGridItem = {
    width: 1,
    align: "middle",
    css: css`
        justify-content: flex-start;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
            ])}
    `,
};
    
    
productCarouselStyles.nextArrowGridItem = {
    width: 1,
    align: "middle",
    css: css`
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
                css`
                    flex-basis: 1%;
                    max-width: 1%;
                `,
            ])}
    `,
};
productCarouselStyles.carouselGridItem = {
    width: 10,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-basis: 98%;
                    max-width: 98%;
                `,
                css`
                    flex-basis: 98%;
                    max-width: 98%;
                `,
                css`
                    flex-basis: 98%;
                    max-width: 98%;
                `,
                css`
                    flex-basis: 98%;
                    max-width: 98%;
                `,
                css`
                    flex-basis: 98%;
                    max-width: 98%;
                `,
            ])}
    `,
};
productCarouselStyles.carouselSlide = {
    css: css`
        padding: 0;
        position: relative;
        flex: 0 0 auto;
        > div {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
    `,
};
productCarouselStyles.carouselSlideInner = {
    css: css`
        width: 85%;
        height: 100%;
        position: relative;
        padding: 0 0 40px 0;
        display: flex;
        flex-direction: column;
        border: 1px solid ${getColor("common.border")};
        margin: 0 auto;
    `,
};
